import React, { useState, useEffect } from 'react';
import '../../../App.css';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
// Bootstrap
import { Breadcrumb, Badge, Row, Col, Button } from 'react-bootstrap';
// Icons
import * as BsIcons from 'react-icons/bs';
import * as RiIcons from 'react-icons/ri';
import * as GiIcons from 'react-icons/gi';
// Imgs
import placeholder from '../../../assets/imgs/placeholder.png';
// Reusable elements
import ScrollToTop from '../../ScrollToTop';
// Translation
import { t } from 'i18next';
// Favorites/UserAuth
import { UserAuth } from '../../../context/AuthContext';


const HeritageRoutes = () => {

  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryFilter = (category) => {
    setSelectedCategory(category);
  }; 

  const handleShowAll = () => {
    setSelectedCategory(null);
  };

  const routes =  [
    {
      id: 0,
      category: "Women",
      title: t('routes.women'),
      time: "1h 30min",
      km: "6km",
      path: t('maps.intermediate'),
      text: t("routes.women_text"),
      img: require('../../../assets/imgs/routes/bassi_docufilm.jpg'),
      copyright: "Unibo",
      more: t('maps.more'),
      link: "/maps/women",
    },
    {
      id: 1,
      category: "Nature",
      title: t('routes.appennini'),
      time: "12h",
      km: "50km",
      path: t('maps.difficult'),
      text: t("routes.appennini_text"),
      img: require('../../../assets/imgs/routes/appennino.jpg'),
      copyright: "Wwikiwalter, CC BY-SA 4.0 <https://creativecommons.org/licenses/by-sa/4.0>, via Wikimedia Commons",
      more: t('maps.more'),
      link: "/maps/appennino"
    },
    {
      id: 2,
      category: "Historical",
      title: t('routes.city_centre'),
      time: "10min",
      km: "650m",
      path: t('maps.easy'),
      img: require('../../../assets/imgs/routes/bologna_free.jpg'),
      copyright: "Free",
      text: t("routes.city_centre_text"),
      more: t('maps.more'),
      link: "/maps/city_centre"
    },
    {
      id: 3,
      category: "Food",
      title: t('routes.food'),
      time: "17min",
      km: "1,2km",
      path: t('maps.easy'),
      text: t("routes.food_text"),
      img: require('../../../assets/imgs/routes/tortellini_Angelo_Muratore.jpg'),
      copyright: "Angelo.Muratore, CC BY-SA 4.0 <https://creativecommons.org/licenses/by-sa/4.0>, via Wikimedia Commons",
      more: t('maps.more'),
      link: "/maps/food"
    },
    {
      id: 4,
      category: "Worship",
      title: t('routes.san_luca'),
      time: "40min",
      km: "2,5km",
      path: t('maps.intermediate'),
      text: t('routes.san_luca_text'),
      img: require('../../../assets/imgs/routes/san_luca_wikipedia_Nebbius.jpg'),
      copyright: "Puscas Vadim  (Nebbius), CC BY-SA 4.0 <https://creativecommons.org/licenses/by-sa/4.0>, via Wikimedia Commons",
      more: t('maps.more'),
      link: "/maps/san_luca"
    },
    {
      id: 5,
      category: "Museum",
      title: t('routes.museum'),
      time: "35min",
      km: "2,4km",
      path: t('maps.easy'),
      text: t("routes.museum_text"),
      img: require('../../../assets/imgs/routes/pinacoteca_Gueraldo_Anna_Chiara.jpg'),
      copyright: "Foto di Anna Chiara Gueraldo",
      more: t('maps.more'),
      link: "/maps/museum"
    },
    {
      id: 6,
      category: "Worship",
      title: t('routes.quebec'),
      time: "2 h",
      km: "8,5km",
      path: t('maps.difficult'),
      text: t("routes.quebec_text"),
      img: require('../../../assets/imgs/routes/quebec.png'),
      copyright: "Krun (original), Public domain, via Wikimedia Commons",
      more: t('maps.more'),
      link: "/maps/quebec"
    },
    {
      id: 5,
      category: "University",
      title: t('routes.canada'),
      time: "1h 45min",
      km: "6,9km",
      path: t('maps.difficult'),
      text: t('routes.canada_text'),
      img: require('../../../assets/imgs/routes/canada.png'),
      copyright: "Illegitimate Barrister (original), Public domain, via Wikimedia Commons",
      more: t('maps.more'),
      link: "/maps/canada"
    },
    {
      id: 6,
      category: "Historical",
      title: t('routes.southamerica'),
      time: "3h 20min",
      km: "13,4 km",
      path: t('maps.difficult'),
      img: require('../../../assets/imgs/routes/hisp.jpg'),
      copyright: "Free",
      text: t('routes.southamerica_text'),
      more: t('maps.more'),
      link: "/maps/southamerica"
    },

  ];

  return (
    <>
    <ScrollToTop/>
    <div className='container-fluid'>
      <Breadcrumb>
        <Breadcrumb.Item><HashLink smooth to='/' id='crumb'>Home</HashLink></Breadcrumb.Item>
        <Breadcrumb.Item>
          <HashLink smooth to="/maps" id='crumb'>
          {t('maps.maps')}
          </HashLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{t('maps.routes_title')}</Breadcrumb.Item>
      </Breadcrumb>
      <h1 className='routes'>{t('maps.routes_title')}</h1>
        <p>{t('maps.routes_text')}</p>
    </div>
    
        <section className='heritage-routes'>
          <div className='container-fluid'>
            <div className='suggested'>
              <br/>
              <h2>{t('maps.suggested_routes')}</h2>
              <hr/>
              <div className='routes-filter-buttons'>
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Food' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Food')}>{t('maps.food_category')}</Button>
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Historical' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Historical')}> {t('maps.historical_category')}</Button>
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Nature' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Nature')}>{t('maps.nature_category')}</Button>
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Museum' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Museum')} >{t('maps.museum_category')}</Button>
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'University' ? 'active' : ''}`} onClick={() => handleCategoryFilter('University')} >{t('maps.button_uni')}</Button> 
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Women' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Women')}>{t('maps.women_category')}</Button> 
                <Button variant='dark' className={`routes-filter ${selectedCategory === 'Worship' ? 'active' : ''}`} onClick={() => handleCategoryFilter('Worship')} >{t('maps.button_worship')}</Button> 
                <Button variant='outline-secondary' className={`routes-filter ${selectedCategory === null ? 'active' : ''}`} onClick={handleShowAll}>{t('maps.all')}</Button>
                <br/>
              </div>
              <br/>
              {routes
            .filter((route) => selectedCategory ? route.category === selectedCategory : true)
            .map((route) => {
                return (
                <>
              <div className='suggested-route' key={route.id}>
                  <h3><span>{route.title}</span></h3>
                  <Row className='routes-icons'>
                    <Col>
                      <RiIcons.RiTimerLine className='routes-icon'/><span>&nbsp;{route.time}</span>
                    </Col>
                    <Col>
                      <GiIcons.GiPathDistance className='routes-icon'/><span>&nbsp;{route.km}</span>
                    </Col>
                    <Col>
                      <GiIcons.GiFootsteps className='routes-icon'/><span>&nbsp;{route.path}</span>
                    </Col>
                  </Row>
                  <img className='side-img'src={`${route.img}`}></img>
                  <p>{route.text}</p>
                  <p style={{textAlign: 'right'}}><span>{route.more}&nbsp;</span><Link to={`${route.link}`}><BsIcons.BsFillArrowRightCircleFill className="more-icon" /></Link></p>
              </div> 
              <br/>
              </>   
              )  
              })}  
            </div>
          </div>
        </section>
        </>
  )
}
export default HeritageRoutes 
